<template>
  <div v-if="loading" class="loading-container">
    <i class="fa fa-spinner fa-spin p-2"></i><span v-if="message">{{message}}</span>
  </div>
  <div v-else>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "loading-panel",
  props: {
    loading: Boolean,
    message: String
  }
};
</script>

<style scoped>
.loading-container {
  width: 100%;
  text-align: center;
}
</style>